// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__qKDsI","emoji":"EmptyState_emoji__j3P6z","text":"EmptyState_text__jew4G"};